import React, { useState } from 'react';
import { Form, Button, Alert, Spinner } from 'react-bootstrap';

const PasswordResetForm = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validación básica
    if (!email) {
      setError('Por favor ingresa tu email');
      return;
    }

    // Validar formato de email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Por favor ingresa un email válido');
      return;
    }

    try {
      setError('');
      setSuccess('');
      setLoading(true);
      
      // TODO: Implement password reset functionality with Supabase
      // await supabase.auth.resetPasswordForEmail(email, {
      //   redirectTo: `${window.location.origin}/admin/reset-password`,
      // });
      
      // Placeholder success message
      setSuccess('Si el email existe en nuestro sistema, recibirás un enlace para restablecer tu contraseña.');
      setEmail('');
      
    } catch (err) {
      console.error('Error al solicitar restablecimiento:', err);
      setError('Error al procesar la solicitud. Por favor intenta nuevamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      {error && (
        <Alert variant="danger" dismissible onClose={() => setError('')}>
          {error}
        </Alert>
      )}

      {success && (
        <Alert variant="success">
          {success}
        </Alert>
      )}

      <Alert variant="info">
        <small>
          Ingresa tu email y te enviaremos un enlace para restablecer tu contraseña.
        </small>
      </Alert>

      <Form.Group className="mb-3" controlId="formEmail">
        <Form.Label>Email</Form.Label>
        <Form.Control
          type="email"
          placeholder="admin@lumieretica.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={loading}
          required
        />
      </Form.Group>

      <Button
        variant="primary"
        type="submit"
        className="w-100 btn-admin-primary"
        disabled={loading}
      >
        {loading ? (
          <>
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
              className="me-2"
            />
            Enviando...
          </>
        ) : (
          'Enviar Enlace de Restablecimiento'
        )}
      </Button>
    </Form>
  );
};

export default PasswordResetForm;
